require('./Login.scss');
import React from 'react';
import PropTypes from 'prop-types';

import Register2 from './register/Register2';
import ExistingUser from './existing-user/ExistingUser';
//import LoginBottom from '../logo-bottom/LogoBottom';
import LoginService from './login-service';
import Alert from '../atoms/Alert';
import { getText } from '../texts/login';
import { loginError, loginType } from '../config/config';
//import Layout from '../layout/Layout';

class Login extends React.Component {
    state = {

    };

    existingUserSubmit(cellphone) {
        return Promise.all([
            LoginService.userExist(cellphone),
            LoginService.userHasPasswordLogin(cellphone),
            LoginService.userHasVippsLogin(cellphone)
        ]).then(([userExist, userHasPasswordLogin, userHasVippsLogin]) => {
            this.setState({

                existingUser: userExist,
                cellphone: cellphone || ''
            });
            return { userExist, userHasPasswordLogin, userHasVippsLogin };
        });
    }

    renderBody() {
        if (this.state.existingUser === false) {
                return (
                    <div>
                        <Register2
                            cellphone={this.state.cellphone}
                            CSRFtoken={this.props.CSRFtoken}
                            redirectURI={this.props.redirectURI}
                            hashContent={this.props.hashContent}
                            UserCheckout={this.props.UserCheckout}
                            targetApplicationId={this.props.targetApplicationId}
                        />
                        {this.renderError()}
                    </div>


                );
        } else {
            return (
                <div>
                    <ExistingUser
                        cellphone={this.props.cellphone}
                        CSRFtoken={this.props.CSRFtoken}
                        redirectURI={this.props.redirectURI}
                        hashContent={this.props.hashContent}
                        UserCheckout={this.props.UserCheckout}
                        SessionCheck={this.props.SessionCheck}
                        promo = {this.props.promo}
                        submit={this.existingUserSubmit.bind(this)}
                        targetApplicationId={this.props.targetApplicationId}
                    />
                    {this.renderError()}
                </div>
            );
        }
    }

    renderError() {
        if (loginError) {
            return (
                <Alert
                    type="error"
                    text={
                        loginType === 'password'
                            ? getText('login.wrong-password')
                            : getText('login.wrong-pin')
                    }
                />
            );
        }
    }

    render() {
        const noPromo = this.props.promo === null || this.state.existingUser===false;

        return (
            <main className="main-background">
                <div className={`grid-container ${noPromo ? 'grid-container-centered' : ''}`}>
                    <div className={`row ${noPromo ? 'row-centered' : ''}`}>
                        <div className={noPromo ? "login-centered-column" : "col-xs-12"}>
                            {this.renderBody()}
                        </div>
                    </div>
                </div>
            </main>
        );
    }
}

Login.propTypes = {
    cellphone: PropTypes.string.isRequired,
    CSRFtoken: PropTypes.string.isRequired,
    redirectURI: PropTypes.string.isRequired,
    hashContent: PropTypes.string.isRequired,
    UserCheckout: PropTypes.string.isRequired,
    SessionCheck: PropTypes.string.isRequired,
    targetApplicationId: PropTypes.string,
    promo: PropTypes.string
};

Login.defaultProps = {
    targetApplicationId: '',
    promo: null
};

export default Login;
